export const ACTUALIZAR_BLOQUEADOS = "ACTUALIZAR_BLOQUEADOS";
export const CARGANDO_BLOQUEADOS = "CARGANDO_BLOQUEADOS";
export const ERROR_BLOQUEADOS = "ERROR_BLOQUEADOS";
